import React,{useEffect} from 'react'
import MidHome from '../Components/MidHome'
import { useNavigate } from 'react-router-dom'
import HomeScreen from '../Components/HomeContent'


export default function Home() {
  const navigator = useNavigate()
//  useEffect(()=>{
//     if(localStorage.getItem("authtoken")){
//         navigator("/repls");
//     }
//   })
  return (
    <>
    <MidHome/>
    <HomeScreen/>
    </>
  )
}
